import './component.scss'
import 'PackWerkNurikaeSite/pages/company/review/partials/local_navigation/component'

import { Controller } from 'stimulus'

const application = window.Stimulus

application.register(
  'nurikae-site-pages-company-review-partials-pc-sticky-header',
  class extends Controller {
    static targets = ["header"]

    connect() {
      this.observer = null;
      
      // 口コミ一覧ページPC用のトリガー要素を取得
      this.triggerElement = document.querySelector('[data-nurikae-site-pages-company-review-partials-pc-sticky-header-target="trigger"]');
      
      if (this.triggerElement) {
        this.setupObserver();
      }
    }

    disconnect() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    setupObserver() {
      const options = { 
        root: null, 
        rootMargin: '0px', 
        threshold: 0 
      };
      
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
      this.observer.observe(this.triggerElement);
    }

    /**
     * トリガー要素が画面内外に移動したときに呼び出されるコールバック
     * @param {IntersectionObserverEntry[]} entries
     */
    handleIntersection(entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          // トリガー要素が画面外に出たら表示
          this.showHeader();
        } else {
          // トリガー要素が画面内に入ったら非表示
          this.hideHeader();
        }
      });
    }

    showHeader() {
      this.headerTarget.classList.add('company-review-sticky-header--visible');
    }

    hideHeader() {
      this.headerTarget.classList.remove('company-review-sticky-header--visible');
    }
  }
)